




































import { Component, Watch, Mixins } from 'vue-property-decorator';
import '@gig/magic-pages';
import { Debounce, FeatureEnabledV2 } from '@gig/magic-common';
import { MetaMixin } from '../../../mixins/meta.mixin';
import { RouteName } from '../../routes.constants';
import { zendeskChat } from '../../../services';
import {
    SEARCH_DEBOUNCE_MS,
    SEARCH_QUERY_PARAM,
} from './faq.constants';
import { Feature } from '../../../util/features';
import { ZendeskLoader } from '../../../components/zendesk-loader';

@Component({
    components: {
        ZendeskLoader,
    },
    beforeRouteEnter(_, __, next) {
        if(zendeskChat?.isLoaded) {
            zendeskChat!.showZendesk?.();
            zendeskChat!.minimizeOnCloseZendesk?.();
        }
        next();
    },

    beforeRouteLeave(this: FaqPage, to, __, next) {
        if(to.name !== RouteName.LIVE_CHAT){
            if(zendeskChat?.isLoaded) {
                zendeskChat!.hideZendesk?.();
                zendeskChat!.registerOnCloseZendesk?.();
            }
        }
        next();
    }
})
export default class FaqPage extends Mixins(MetaMixin) {
    query: string | Array<string | null> = '';
    
    @FeatureEnabledV2({
        slug: Feature.TOP_NAVIGATION,
    })
    isTopNavigationEnabled = false;

    @FeatureEnabledV2({ slug: Feature.ENHANCED_COVERS_ON_STATIC_PAGES })
    enhancedCoversOnStaticPages: boolean = false;

    created() {
        this.setPage('faqs');
        this.query = this.$route.query[SEARCH_QUERY_PARAM] || '';
    }

    mounted() {
        zendeskChat!.minimizeOnCloseZendesk?.();
    }

    @Watch('query')
    @Debounce(SEARCH_DEBOUNCE_MS)
    search() {
        if (!this.query) {
            this.$router.push({ name : RouteName.FAQ_CATEGORIES });
            return;
        }

        const newRoute = {
            name: RouteName.FAQ_SEARCH,
            query: this.query ? { [SEARCH_QUERY_PARAM]: this.query } : undefined,
        };

        if (this.$route.name === RouteName.FAQ_SEARCH) {
            this.$router.replace(newRoute);
        } else {
            this.$router.push(newRoute);
        }
    }
}
